import { ClockIcon, PlusInSquareIcon } from "assets/icons";
import { toastServerError } from "helpers";
import { useBoolean } from "hooks";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "ui";

import { useMarketingFlows, useRunMarketingFlows } from "../../apis";
import { FlowCards, FlowModal } from "../../components";

import styles from "./MarketingFlows.module.scss";

const MarketingFlows = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { flows, isLoading } = useMarketingFlows();

  const {
    value: isFlowModalOpen,
    setTrue: openFlowModal,
    setFalse: closeFlowModal
  } = useBoolean(false);

  const { mutate: runFlows, isLoading: isRunning } = useRunMarketingFlows({
    onSuccess: () => toast.success(t("Scheduler run completed")),
    onError: toastServerError
  });

  return (
    <div className={styles.flows}>
      <div className={styles.flows__controls}>
        <p className={styles.flows__hint}>
          {t(
            "Each nurturing scenario is a flow: a trigger, a cadence and a sequence of steps. Contacts auto-enroll on events; the scheduler advances them every hour."
          )}
        </p>

        <div className={styles.flows__actions}>
          <Button
            variant="default"
            icon={<ClockIcon width={16} height={16} />}
            loading={isRunning}
            onClick={() => runFlows()}
          >
            {t("Run scheduler now")}
          </Button>

          <Button icon={<PlusInSquareIcon />} onClick={openFlowModal}>
            {t("New flow")}
          </Button>
        </div>
      </div>

      <FlowCards flows={flows} isLoading={isLoading} />

      <FlowModal
        isOpen={isFlowModalOpen}
        editableFlow={null}
        onClose={closeFlowModal}
        onCreated={(flow) => navigate(`/marketing/flows/${flow.id}`)}
      />
    </div>
  );
};

export default MarketingFlows;
